import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_ADMIN_USER = "ADMIN-USER:GET_ADMIN_USER";

export interface GetAdminUserAction extends Action {
  type: typeof GET_ADMIN_USER;
  organization: OrganizationKeyName;
  id: string;
}

export const getAdminUserAction = (
  organization: OrganizationKeyName,
  id: string
): GetAdminUserAction => ({
  type: GET_ADMIN_USER,
  organization,
  id,
});
